import { i18n } from "services/i18nService";

export const QUANTITY_ON_HAND_NOT_ZERO = "QUANTITY_ON_HAND_NOT_ZERO";
export const ID_NOT_FOUND = "ID_NOT_FOUND";
export const NAME_VALUE_REQUIRED = "NAME_VALUE_REQUIRED";
export const DUPLICATE_NAME = "DUPLICATE_NAME";
export const OVER_DEPARTMENT_CLASS_LIMIT = "OVER_DEPARTMENT_CLASS_LIMIT";
export const LOCATION_HAS_QUANTITY_ON_HAND = "LOCATION_HAS_QUANTITY_ON_HAND";
export const WARRANTY_REFERENCED_BY_ITEMS = "WARRANTY_REFERENCED_BY_ITEMS";
export const WARRANTY_REFERENCED_BY_SERIALS = "WARRANTY_REFERENCED_BY_SERIALS";
export const CONCURRENCY_CONFLICT = "CONCURRENCY_CONFLICT";
export const BIN_HAS_CONTENTS = "BIN_HAS_CONTENTS";
export const INVALID_SHOPIFY_ACCESS_TOKEN = "INVALID_SHOPIFY_ACCESS_TOKEN";

export function getErrorCodeMessage(errorCode, details) {
  switch (errorCode) {
    case QUANTITY_ON_HAND_NOT_ZERO:
      const messages = details.map(({ item, locations }) => {
        const locationNames = locations.map(({ name }) => name).join(", ");
        return `${item.name} (Locations: ${locationNames})`;
      });
      return `${i18n("errorCode.QUANTITY_ON_HAND_NOT_ZERO")} ${messages.join(
        "; "
      )};`;
    case BIN_HAS_CONTENTS:
      const binMessage = details.map(({ bin, items }) => {
        const itemNames = items.map(({ name }) => name).join(", ");
        return `${bin.name} (Items: ${itemNames})`;
      });
      return i18n("errorCode.BIN_HAS_CONTENTS", {
        binList: binMessage.join("; "),
      });
    case ID_NOT_FOUND:
      return i18n("global.SomethingWentWrong");
    case NAME_VALUE_REQUIRED:
      return i18n("errorCode.NAME_VALUE_REQUIRED");
    case DUPLICATE_NAME:
      return i18n("errorCode.DUPLICATE_NAME");
    case OVER_DEPARTMENT_CLASS_LIMIT:
      return i18n(
        details > 0
          ? "errorCode.OVER_DEPARTMENT_CLASS_LIMIT_OVER_ZERO"
          : "errorCode.OVER_DEPARTMENT_CLASS_LIMIT_ZERO",
        {
          limit: details,
        }
      );
    case LOCATION_HAS_QUANTITY_ON_HAND:
      return `${i18n(
        "errorCode.LOCATION_QUANTITY_ON_HAND_NOT_ZERO"
      )} ${details.join(", ")}`;

    case WARRANTY_REFERENCED_BY_ITEMS:
    case WARRANTY_REFERENCED_BY_SERIALS:
      const messageKey =
        details.more > 0
          ? "errorCode.WARRANTY_IS_ASSIGNED_MORE"
          : "errorCode.WARRANTY_IS_ASSIGNED";
      const warrantyType =
        errorCode === WARRANTY_REFERENCED_BY_ITEMS ? "ITEM" : "SERIAL";
      const typeKey = `errorCode.WARRANTY_TYPE_${warrantyType}`;
      return `${i18n(messageKey, {
        type: i18n(typeKey),
        more: details.more > 0 ? details.more + 10 : null,
      })} ${details.firstTen.join(", ")}`;
    default:
      return null;
  }
}
